import { Button, Box, Grid, Typography } from "@mui/material";
import MicrosoftLogo from "../../assets/images/Microsoft.png";
import CSIPAYLogo from "../../assets/images/CSI_PAY_Logo.png";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

import { loginRequest } from "../../authConfig";
import { useEffect, useCallback, useRef } from "react";
import { setSession } from "../../utils/jwt";
import { InteractionRequiredAuthError, AuthError } from "@azure/msal-browser";

export default function LoginPage() {
  const { instance, accounts, inProgress } = useMsal();
  const tokenAcquired = useRef(false);

  const getToken = useCallback(async () => {
    if (accounts.length === 0 || tokenAcquired.current) return;

    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
        scopes: [process.env.REACT_APP_API_SCOPE].filter(
          (s): s is string => typeof s === "string"
        ),
      });
      setSession(response.accessToken);
      tokenAcquired.current = true;
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        console.log("Interaction required - user needs to log in again");
        // Don't automatically redirect here - let user click the button
        tokenAcquired.current = false;
      } else if (e instanceof AuthError) {
        console.error("AuthError details:", e.errorCode, e.errorMessage);
      } else {
        console.error("Token error:", e);
      }
    }
  }, [accounts, instance]);

  const handleRedirect = async () => {
    if (inProgress !== InteractionStatus.None) return;
    await instance.loginRedirect({
      ...loginRequest,
    });
  };

  // After redirect completes or when user is already signed in, try to get token silently
  useEffect(() => {
    if (inProgress === InteractionStatus.None && accounts.length > 0) {
      void getToken();
    }
  }, [inProgress, accounts.length, getToken]);

  return (
    <Grid container direction="column" alignItems="center">
      <Typography variant="h2" color="black">
        <img src={CSIPAYLogo} alt="CSI Pay logo" />
      </Typography>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Button
          sx={{
            fontFamily: "Segoe UI",
            fontSize: "15px",
            fontWeight: 600,
            color: "#ffffff",
            backgroundColor: "#2f2f2f",
            height: "41px",
            "&:hover": { backgroundColor: "#3f3f3f" },
          }}
          onClick={handleRedirect}
          disabled={inProgress !== InteractionStatus.None}
        >
          <img src={MicrosoftLogo} alt="Microsoft logo" /> &nbsp; Sign in with
          Microsoft
        </Button>
      </Box>
    </Grid>
  );
}
